var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { padding: "20px" } },
    [
      _c(
        "div",
        { staticClass: "closeCurrntPage", on: { click: _vm.closeCurrntPage } },
        [_vm._v("X关闭当前页")]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "gap-bottom",
          attrs: { flex: "main:justify cross:center" }
        },
        [
          _c("div"),
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "upload-excel-component",
                {
                  ref: "uploadExcel",
                  staticStyle: {
                    display: "inline-block",
                    "z-index": "-999999",
                    top: "-999999999px",
                    position: "fixed"
                  },
                  attrs: { "on-success": _vm.importExcel }
                },
                [_vm._v("导入")]
              ),
              _vm._v(" "),
              _c(
                "el-tooltip",
                {
                  staticClass: "item",
                  attrs: {
                    effect: "light",
                    content:
                      "导出格式不能修改；仅物流承运商、物流运单号支持维护",
                    placement: "bottom"
                  }
                },
                [
                  _c(
                    "el-dropdown",
                    {
                      staticClass: "batchbtn",
                      attrs: {
                        trigger: "click",
                        size: "medium",
                        placement: "bottom"
                      },
                      on: { command: _vm.handleCommand }
                    },
                    [
                      _c(
                        "el-button",
                        { attrs: { type: "primary", size: "small" } },
                        [
                          _vm._v("\n            批量录入\n            "),
                          _c("i", {
                            staticClass: "el-icon-caret-bottom el-icon--right"
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-dropdown-menu",
                        { attrs: { slot: "dropdown" }, slot: "dropdown" },
                        [
                          _c("el-dropdown-item", { attrs: { command: "b" } }, [
                            _vm._v("导出表格")
                          ]),
                          _vm._v(" "),
                          _c("el-dropdown-item", { attrs: { command: "a" } }, [
                            _vm._v("导入表格")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading"
                }
              ],
              attrs: {
                "row-class-name": _vm.tableRowClassName,
                border: "",
                data: _vm.tableData
              }
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "index",
                  label: "序号",
                  width: "50",
                  align: "center"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "id", label: "ID", width: "80" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "created_at", label: "推送日期", width: "125" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "main_number", label: "主订单号", width: "125" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "serial_number", label: "编号", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.serial_number
                          ? _c("span", [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    scope.row.serial_number
                                      .split("-")
                                      .slice(3)
                                      .join("-")
                                  ) +
                                  "\n          "
                              )
                            ])
                          : _vm._e()
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              !_vm.isFactory
                ? _c("el-table-column", {
                    attrs: { prop: "box_num", label: "打包箱数", width: "60" }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "user_name", label: "客户姓名", width: "60" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "mobile", label: "客户电话", width: "120" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "address", label: "客户地址", width: "120" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "courier_code",
                  label: "物流承运商",
                  width: "145"
                },
                scopedSlots: _vm._u([
                  {
                    key: "header",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: {
                              effect: "light",
                              content:
                                "按照选项[物流承运商]录入。若需录入的物流承运商在档案中没有，请提供给系统管理员维护。",
                              placement: "bottom"
                            }
                          },
                          [
                            _c("span", { staticClass: "el-icon-question" }, [
                              _vm._v("物流承运商")
                            ])
                          ]
                        )
                      ]
                    }
                  },
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              value: scope.row.courierName,
                              size: "mini",
                              filterable: "",
                              "filter-method": _vm.filterMethod,
                              clearable: ""
                            },
                            on: {
                              change: function(e) {
                                return _vm.handleChangeCourier(e, scope)
                              },
                              clear: _vm.setTsListShort
                            }
                          },
                          _vm._l(_vm.tsListShort, function(item) {
                            return _c("el-option", {
                              key: item.provider_code,
                              attrs: {
                                label: item.provider_name,
                                value: item.provider_code + ""
                              }
                            })
                          }),
                          1
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "courier_number", label: "物流运单号" },
                scopedSlots: _vm._u([
                  {
                    key: "header",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: { effect: "light", placement: "bottom" }
                          },
                          [
                            _c(
                              "div",
                              { attrs: { slot: "content" }, slot: "content" },
                              [
                                _c("div", [
                                  _vm._v("a.将单元格格式设置为文本；")
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _vm._v(
                                    "\n                b.若一个单据存在多个运单号，请用半角英文状态下的逗号“,”隔开。\n              "
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "el-icon-question" }, [
                              _vm._v("物流运单号")
                            ])
                          ]
                        )
                      ]
                    }
                  },
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "div",
                          [
                            _c("el-input", {
                              attrs: {
                                type: "textarea",
                                autosize: { minRows: 1, maxRows: 10 },
                                placeholder: "多个运单号，请用英文逗号“,”隔开"
                              },
                              model: {
                                value: scope.row.courier_number,
                                callback: function($$v) {
                                  _vm.$set(
                                    scope.row,
                                    "courier_number",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "scope.row.courier_number"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "courier_mobile", label: "物流联系电话" },
                scopedSlots: _vm._u([
                  {
                    key: "header",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: { effect: "light", placement: "bottom" }
                          },
                          [
                            _c(
                              "div",
                              { attrs: { slot: "content" }, slot: "content" },
                              [_c("div", [_vm._v("将单元格格式设置为文本")])]
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "el-icon-question" }, [
                              _vm._v("物流联系电话")
                            ])
                          ]
                        )
                      ]
                    }
                  },
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "div",
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: "请填写物流联系电话",
                                size: "small"
                              },
                              model: {
                                value: scope.row.courier_mobile,
                                callback: function($$v) {
                                  _vm.$set(scope.row, "courier_mobile", $$v)
                                },
                                expression: "scope.row.courier_mobile"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "count-wrap", attrs: { flex: "main:start" } }, [
        _c("div", [_vm._v("合计")]),
        _vm._v(" "),
        _c("div", [_vm._v("主订单数量：" + _vm._s(_vm.mainNumberCount))]),
        _vm._v(" "),
        !_vm.isFactory
          ? _c("div", [_vm._v("打包箱数：" + _vm._s(_vm.boxNumberCount))])
          : _vm._e(),
        _vm._v(" "),
        !_vm.isFactory
          ? _c("div", [_vm._v("单号数：" + _vm._s(_vm.tsNumberCount))])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "gap-top", attrs: { flex: "main:center" } },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "mini" },
              on: { click: _vm.saveHandler }
            },
            [_vm._v("保存")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "确认",
            visible: _vm.dialogVisible,
            center: "",
            "append-to-body": "",
            width: "500px"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticStyle: { "text-align": "center" } },
            [
              _c(
                "el-row",
                {
                  staticStyle: { "margin-bottom": "20px" },
                  attrs: { type: "flex", justify: "center", align: "middle" }
                },
                [
                  _c("el-col", { attrs: { span: 8 } }, [
                    _c("div", [_vm._v("类型")])
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "是否包含商品明细" },
                          model: {
                            value: _vm.detailed,
                            callback: function($$v) {
                              _vm.detailed = $$v
                            },
                            expression: "detailed"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "含商品明细", value: 1 }
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "不含商品明细", value: 0 }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.detailed == 0,
                      expression: "detailed == 0"
                    }
                  ],
                  staticStyle: { "margin-bottom": "20px" },
                  attrs: { type: "flex", justify: "center", align: "middle" }
                },
                [
                  _c("el-col", { attrs: { span: 8 } }, [
                    _c("div", [_vm._v("是否合并数据")])
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-radio",
                        {
                          attrs: { label: 1 },
                          model: {
                            value: _vm.isExpend,
                            callback: function($$v) {
                              _vm.isExpend = $$v
                            },
                            expression: "isExpend"
                          }
                        },
                        [_vm._v("是")]
                      ),
                      _c(
                        "el-radio",
                        {
                          attrs: { label: 0 },
                          model: {
                            value: _vm.isExpend,
                            callback: function($$v) {
                              _vm.isExpend = $$v
                            },
                            expression: "isExpend"
                          }
                        },
                        [_vm._v("否")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.detailed == 0,
                      expression: "detailed == 0"
                    }
                  ]
                },
                [
                  _vm._v(
                    "\n        （当客户名称、客户电话、客户地址完全一致时）\n      "
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.dialogVisible = false
                    }
                  }
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.confirm } },
                [_vm._v("导出")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-463a92af", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-463a92af","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/bigorder/input-ts.vue
// module id = null
// module chunks = 